import React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@fluentui/react-components';
import { DismissRegular, CheckmarkCircleRegular } from '@fluentui/react-icons';

interface NotificationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

const NotificationDialog: React.FC<NotificationDialogProps> = ({
  isOpen,
  onClose,
  message,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={onClose}
              />
            }
          >
            Notifiering
          </DialogTitle>
          <DialogContent>
            <div className="flex items-center gap-3">
              <CheckmarkCircleRegular className="text-green-600 w-6 h-6" />
              <p className="text-sm">{message}</p>
            </div>
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={onClose}>
              OK
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default NotificationDialog;
